const LocaleSpecificNoticeMappingToURL = ({ replaceUrl = '', replaceText = '' }) => ({
  replaceUrl: String(replaceUrl),
  replaceText: String(replaceText),
});

const LocaleSpecificNotice = ({ id = '', mappings = [], text = '' } = {}) => ({
  id: String(id),
  mappings: mappings.map(LocaleSpecificNoticeMappingToURL),
  text: String(text),
});

export default LocaleSpecificNotice;

export type LocaleSpecificNoticeProps = ReturnType<typeof LocaleSpecificNotice>;
